import {
    FilterData,
    FilterBlockTypesEnum,
} from "../../src/apis/stateful-content";
const fs = require("fs");
const output = `${__dirname}/../../resources/generated-mock-data/`;

const response: FilterData = {
    filterBlocks: [
        {
            type: FilterBlockTypesEnum.Dropdown,
            placeholder: "Technologies",
            name: "technologies",
            filterable: true,
            filterItems: [
                {
                    name: "item1",
                    value: "item1",
                    label: "Item 1",
                    active: false,
                    count: 5,
                },
                {
                    name: "item2",
                    value: "item2",
                    label: "Item 2",
                    active: false,
                    count: 2,
                },
                {
                    name: "item3",
                    value: "item3",
                    label: "Item 3",
                    active: false,
                    count: 3,
                },
                {
                    name: "item4",
                    value: "item4",
                    label: "Item 4",
                    active: false,
                    count: 2,
                },
                {
                    name: "item5",
                    value: "item5",
                    label: "Item 5",
                    active: false,
                    count: 5,
                },
                {
                    name: "item6",
                    value: "item6",
                    label: "Item 6",
                    active: false,
                    count: 1,
                },
                {
                    name: "item7",
                    value: "item7",
                    label: "Item 7",
                    active: false,
                    count: 4,
                },
            ],
        },
        {
            type: FilterBlockTypesEnum.Checkbox,
            filterItems: [
                {
                    name: "isFav",
                    value: "isFav",
                    label: "Nur Favoriten",
                    active: false,
                    count: 2,
                },
            ],
        },
    ],
};

const writeToFile = (object: FilterData, name: string) => {
    fs.writeFileSync(`${output}${name}.json`, JSON.stringify(object));
};

writeToFile(response, "mymachine-stateful-filter");
